<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>    
                <v-btn icon href="/scheduled-mail-notification">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>  
                {{ 'Scheduled Email Notifications' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="9" md="9">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>
                      <v-row v-if="cycleerrors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            outlined
                            type="error"
                          >{{cycleerrors}}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Template name' | translate"
                            v-model="template_name"
                            name="template_name"
                            autocomplete="off"
                            :rules="templatenameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                    v-model="sendGroup"
                                    :items="recipientType"
                                    item-value="value"
                                    item-text="text"
                                    :label="'Select Recipient Type' | translate"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    @change="getRecipients()"
                                    :rules="recipientRules"
                                    :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-if="sendGroup=='group'">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                v-model="userGroupList"
                                :items="groups"
                                item-value="group_id"
                                :item-text="item =>`${item.group_name}`"
                                :label="'User Group' | translate"
                                outlined
                                chips
                                small-chips
                                multiple
                                required
                                :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>  

                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-if="sendGroup=='users'">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                v-model="userList"
                                :items="users"
                                item-value="user_id"
                                :item-text="item =>`${item.name} (${item.email})`"
                                :label="'Users' | translate"
                                outlined
                                chips
                                small-chips
                                multiple
                                required
                                :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>  

                                </v-autocomplete>
                            </v-col>
                        </v-row>
                           
                        <v-row>
                            <v-col cols="12" sm="12">
                                <h3>{{"Scheduler Settings" | translate}}</h3>
                                <v-row>
                                <v-col cols="12" md="12" sm="12">
                                     <v-autocomplete
                                        v-model="frequency"
                                        :items="frequencyType"
                                        item-value="value"
                                        item-text="text"
                                        :label="'Select Frequency' | translate"
                                        outlined
                                        chips
                                        small-chips
                                        :rules="frequencyRules"
                                        required
                                        :no-data-text="$t('No data available')"
                                    >
                                    <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>
                                    </v-autocomplete>
                                </v-col>
                                </v-row>

                                <v-row>
                                <v-col cols="12" md="6" sm="6">
                                      <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="start_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="start_date"
                                            :label="'Start Date' | translate"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="start_date"
                                        no-title
                                        scrollable
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            :color="primary_color"
                                            @click="menu = false"
                                        >
                                            {{"Cancel" | translate}}
                                        </v-btn>
                                        <v-btn
                                            text
                                            :color="primary_color"
                                            @click="$refs.menu.save(start_date)"
                                        >
                                            {{"OK" | translate}}
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2" sm="2">
                                 <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="start_time"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="start_time"
                                      :label="'Time' | translate"
                                      prepend-icon="mdi-clock-time-four-outline"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="menu2"
                                    v-model="start_time"
                                    full-width
                                    @click:minute="$refs.menu2.save(start_time)"
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>

                              <v-col cols="12" md="3" sm="3">
                                <span class="v-input mt-6">{{"Timezone" | translate}} ({{timezone | translate}})</span>
                              </v-col>

                                </v-row>

                                <v-row>
                                <v-col cols="12" md="12" sm="12">
                                     <v-text-field 
                                        v-model="cycles"
                                        :label="campaignTypeLabel | translate"
                                        outlined
                                        type="number"
                                        autocomplete="off"
                                        required
                                        min="0"
                                        @keyup="resetCycleCounts()"
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                    <p class="mt-n3">
                                        {{'Add Cycle Count, If you want Endless Cycle set value to 0.' | translate}}
                                    </p> 
                                </v-col>
                                </v-row>

                                <v-row>
                                     <v-switch
                                    v-model="campaignswitch"
                                    :label="`Campaign? ${campaignLabel}` | translate"
                                    :disabled="(template_id? true : false)"
                                    ></v-switch>
                                </v-row>

                            </v-col>
                        </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12" class="mt-n3 pb-4">
                            <h3>{{'Placeholders' | translate}}</h3>
                            <span class="pa-2"> {{"You can choose these placeholders while constructing Email" | translate}} </span>
                            <div>
                                <v-chip
                                class="ma-2 mb-4"
                                @click="addplaceholder(userEmail)"
                                >
                                 {{userEmail}}
                                </v-chip>
                                <v-chip
                                class="ma-2 mb-4"
                                @click="addplaceholder(userName)"
                                >
                                {{userName}}
                                </v-chip>
                                <span id="custom-tooltip">{{"Copied to Clipboard!" | translate}} </span>
                            </div>
                        </v-col>
                      </v-row>


                      <div v-if="missing_fields_error_message" class="v-messages theme--light error--text" role="alert">
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                              {{missing_fields_error_message}}
                          </div>
                        </div>
                      </div>

                      <v-tabs v-if="!campaignswitch"
                      v-model="tabs"
                      >
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab  
                          v-for="language in availablelanguages" :key="language.lang_id" 
                          :href="'#'+language.lang_code">
                          <span v-if="company_default_language===language.lang_code" 
                          style="color: #dc3545!important;">*</span>
                            {{ language.lang_name | translate}} 
                        </v-tab>
                      </v-tabs>
            
                      <v-tabs-items v-model="tabs" v-if="!campaignswitch">
                          <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                  outlined
                                  :label="'Subject in ' +language.lang_name| translate"
                                  v-model="template_subject[index]"
                                  name="subject"
                                  autocomplete="off"
                                  required
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                
                                <div class="mb-3 mt-n2 pb-6"> <span class="title">{{"Email in " +language.lang_name| translate}}</span>
                                  <div class="d-flex test-mail-section">
                                      <div class="d-flex test-mail-input" v-if="test_mail_input">
                                        <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                        <v-btn
                                          elevation="2"
                                          small
                                          class="white--text mt-1" :color="primary_color"
                                          @click="sendTestMail(language, 1)"
                                        > 
                                        <v-progress-circular
                                          indeterminate
                                          :size="20"
                                          :width="2"
                                          color="white"
                                          v-if="sendingTestMailInProgress"
                                        ></v-progress-circular>
                                        {{"Send" | translate}} </v-btn>
                                      </div>
                                      <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                          <v-btn
                                            elevation="2"
                                            small
                                            class="white--text btn" :color="primary_color"
                                            v-if="template_id && templateEdited"
                                            @click="toggleMailInput"
                                          > {{"Send Test Mail" | translate}}</v-btn>
                                      </div>
                                  </div>
                                  
                                </div>
                                  
                                  <template>
                                      <div id="app">
                                          <tiptap 
                                          v-model="template[index]"
                                          />
                                      </div>
                                  </template>

                              </v-col>
                            </v-row>
                          </v-tab-item>    
                      </v-tabs-items>  
                      
                      <v-card outlined class="mt-6 pa-3" v-for="(emailtemplate,i) in emailtemplates" :key="i">
                            <v-row>
                              <v-col cols="6" sm="6" md="6">
                                <v-text-field 
                                    v-model="emailtemplates[i]['from_cycle']"
                                    :label="'From Cycle'| translate"
                                    outlined
                                    type="number"
                                    autocomplete="off"
                                    required
                                    min="2"
                                    :disabled="!i"
                                    @change="validateextrafields(i)"
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-text-field>

                                <div v-if="from_error_message.length" class="v-messages theme--light error--text" role="alert">
                                  <div class="v-messages__wrapper">
                                    <div class="v-messages__message">
                                        {{from_error_message[i]}}
                                    </div>
                                  </div>
                                </div>
                              </v-col>

                              <v-col cols="5" sm="5" md="5">
                                <span class="v-input mt-6">{{"To Cycle"| translate}} {{emailtemplates[i]['to_cycle']}}</span>
                              </v-col>

                              <v-col cols="1" sm="1" md="1">
                                <v-icon :disabled="!i" class="mr-2" v-on:click="handleDelete(i)" >delete</v-icon>
                              </v-col>

                            </v-row>

                            <v-col cols="12" sm="12" md="12" class="mt-n6">
                                <v-tabs
                                    v-model="campaigntabs[i]"
                                >
                                    <v-tabs-slider></v-tabs-slider>
                                    <v-tab  
                                    v-for="language in availablelanguages" :key="language.lang_id" 
                                    :href="'#'+language.lang_code">
                                    <span v-if="company_default_language===language.lang_code" 
                                    style="color: #dc3545!important;">*</span>
                                        {{ language.lang_name | translate}} 
                                    </v-tab>
                                </v-tabs>
                    
                                <v-tabs-items v-model="campaigntabs[i]">
                                    <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                                      
                                        <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field
                                            outlined
                                            :label="'Subject in ' +language.lang_name| translate"
                                            v-model="emailtemplates[i]['template_subject'][index]"
                                            name="subject"
                                            autocomplete="off"
                                            required
                                            >
                                            <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                            </template>                            
                                            </v-text-field>
                                        </v-col>
                                        </v-row>

                                        <v-row>
                                        <v-col cols="12" sm="12">
                                            
                                            <div class="mb-3 mt-n2 pb-6"> <span class="title">{{"Email in " +language.lang_name| translate}}</span>
                                            <div class="d-flex test-mail-section">
                                                <div class="d-flex test-mail-input" v-if="test_mail_input">
                                                    <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                                    <v-btn
                                                    elevation="2"
                                                    small
                                                    class="white--text mt-1" :color="primary_color"
                                                    @click="sendTestMail(language,emailtemplates[i]['from_cycle'])"
                                                    > 
                                                    <v-progress-circular
                                                      indeterminate
                                                      :size="20"
                                                      :width="2"
                                                      color="white"
                                                      v-if="sendingTestMailInProgress"
                                                    ></v-progress-circular>
                                                    {{"Send" | translate}} </v-btn>
                                                </div>
                                                <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                                    <v-btn
                                                        elevation="2"
                                                        small
                                                        class="white--text btn" :color="primary_color"
                                                        v-if="template_id"
                                                        @click="toggleMailInput"
                                                    > {{"Send Test Mail" | translate}}</v-btn>
                                                </div>
                                            </div>
                                            
                                            </div>
                                            
                                            <template>
                                                <div id="app">
                                                    <tiptap 
                                                    v-model="emailtemplates[i]['template'][index]"
                                                    />
                                                </div>
                                            </template>

                                        </v-col>
                                        </v-row>
                                    </v-tab-item>    
                                </v-tabs-items>  
                            </v-col>
                      </v-card>

                        <v-row>
                            <v-col cols="12">
                                <v-card-text class="pb-4 title" v-if="canAddTemplate" @click="addTemplate" style="cursor: pointer" >{{ 'Add Template' | translate}}
                                <v-icon >mdi-plus-box</v-icon>
                                </v-card-text>   
                            </v-col>
                        </v-row>

                      <v-card outlined class="mt-6 pa-3" v-for="(emailtemplate,i) in emailtemplates" :key="i">
                            <v-row>
                              <v-col cols="6" sm="6" md="6">
                                <v-text-field 
                                    v-model="emailtemplates[i]['from_cycle']"
                                    :label="'From Cycle'| translate"
                                    outlined
                                    type="number"
                                    autocomplete="off"
                                    required
                                    min="2"
                                    :disabled="!i"
                                    @change="validateextrafields(i)"
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-text-field>

                                <div v-if="from_error_message.length" class="v-messages theme--light error--text" role="alert">
                                  <div class="v-messages__wrapper">
                                    <div class="v-messages__message">
                                        {{from_error_message[i]}}
                                    </div>
                                  </div>
                                </div>
                              </v-col>

                              <v-col cols="5" sm="5" md="5">
                                <span class="v-input mt-6">{{"To Cycle"| translate}} {{emailtemplates[i]['to_cycle']}}</span>
                              </v-col>

                              <v-col cols="1" sm="1" md="1">
                                <v-icon :disabled="!i" class="mr-2" v-on:click="handleDelete(i)" >delete</v-icon>
                              </v-col>

                            </v-row>

                            <v-col cols="12" sm="12" md="12" class="mt-n6">
                                <v-tabs
                                    v-model="campaigntabs[i]"
                                >
                                    <v-tabs-slider></v-tabs-slider>
                                    <v-tab  
                                    v-for="language in availablelanguages" :key="language.lang_id" 
                                    :href="'#'+language.lang_code">
                                    <span v-if="company_default_language===language.lang_code" 
                                    style="color: #dc3545!important;">*</span>
                                        {{ language.lang_name | translate}} 
                                    </v-tab>
                                </v-tabs>
                    
                                <v-tabs-items v-model="campaigntabs[i]">
                                    <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                                      
                                        <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field
                                            outlined
                                            :label="'Subject in ' +language.lang_name| translate"
                                            v-model="emailtemplates[i]['template_subject'][index]"
                                            name="subject"
                                            autocomplete="off"
                                            required
                                            >
                                            <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                            </template>                            
                                            </v-text-field>
                                        </v-col>
                                        </v-row>

                                        <v-row>
                                        <v-col cols="12" sm="12">
                                            
                                            <div class="mb-3 mt-n2 pb-6"> <span class="title">{{"Email in " +language.lang_name| translate}}</span>
                                            <div class="d-flex test-mail-section">
                                                <div class="d-flex test-mail-input" v-if="test_mail_input">
                                                    <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                                    <v-btn
                                                    elevation="2"
                                                    small
                                                    class="white--text mt-1" :color="primary_color"
                                                    @click="sendTestMail(language,emailtemplates[i]['from_cycle'])"
                                                    > {{"Send" | translate}} </v-btn>
                                                </div>
                                                <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                                    <v-btn
                                                        elevation="2"
                                                        small
                                                        class="white--text btn" :color="primary_color"
                                                        v-if="template_id"
                                                        @click="toggleMailInput"
                                                    > {{"Send Test Mail" | translate}}</v-btn>
                                                </div>
                                            </div>
                                            
                                            </div>
                                            
                                            <template>
                                                <div id="app">
                                                    <tiptap 
                                                    v-model="emailtemplates[i]['template'][index]"
                                                    />
                                                </div>
                                            </template>

                                        </v-col>
                                        </v-row>
                                    </v-tab-item>    
                                </v-tabs-items>  
                            </v-col>
                      </v-card>

                        <v-row>
                            <v-col cols="12">
                                <v-card-text class="pb-4 title" v-if="canAddTemplate" @click="addTemplate" style="cursor: pointer" >{{ 'Add Template' | translate}}
                                <v-icon >mdi-plus-box</v-icon>
                                </v-card-text>   
                            </v-col>
                        </v-row>

                      

                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>

                          
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  FETCH_LANGUAGES,
  FETCH_INDIVIDUAL_SCHEDULED_MAIL_TEMPLATE,
  SEND_SCHEDULED_TEST_MAIL, 
  ADD_SCHEDULED_MAIL_TEMPLATE,
  UPDATE_SCHEDULED_MAIL_TEMPLATE,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_COMPANY_SETTINGS,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import tiptap from '@/components/tiptap/tiptap.vue'
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addcustomemailtemplate",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE)
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
        await store.dispatch(FETCH_LANGUAGES, ""),
        await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile')
    ]).then(() => {
        store.commit(SET_LOADING, false)
      }) 
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_SCHEDULED_MAIL_TEMPLATE, to.params.id)
      
    }

    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  components: { tiptap }, 
  computed: {
    ...mapGetters(['adminusers','languages', 'sindividualtemplate', 'currentUser', 'curLanguage', 'companysettings']),
    ...mapState({
      errors: state => state.groups.grouperrors,
    }),
    templatenameRules(){  return [v => !!v || "Template name is required"]},
    recipientRules(){  return [v => !!v || "Recipient is required"]},
    frequencyRules(){  return [v => !!v || "Frequency is required"]},
    emailRules(){ 
      return [v => /.+@.+/.test(v) || this.$t("Invalid Email address")]
    },
    recipientType(){
      return [
          {value: 'group', text:this.$t('Group')},
          {value: 'users', text:this.$t('Users')},
          {value: 'all_users', text:this.$t('All Users')}
      ]
    },
    frequencyType(){
      return [
          {value: 'daily', text:this.$t('Daily')},
          {value: 'weekly', text:this.$t('Weekly')},
          {value: 'monthly', text:this.$t('Monthly')},
          {value: 'yearly', text:this.$t('Yearly')},
      ]
    },
    isUser(){
      //User can be company admin as well, in this case role of company admin supersedes that of user
      if(this.currentUser.roles.includes(1)){
        return false;
      }
      return this.currentUser.roles.includes(4) 
    }, 
    canAddTemplate(){
        if(this.campaignswitch && !this.reachedMaxTemplateCount){
            return true;
        }
        return false;
    },
    availablelanguages(){
      let availablelanguages=[];

      let selectedLang = this.languages.filter(data =>data.lang_code == this.company_default_language)
      selectedLang.forEach((lang) => {
        availablelanguages.push(lang);
      });
      
      let otherlang = this.languages.filter(data =>data.lang_code != this.company_default_language)
      otherlang.forEach((lang) => {
        availablelanguages.push(lang);
      });
      return availablelanguages;
    },
    campaignTypeLabel(){
        return this.campaignswitch?'Total Cycles':'Cycles';
    },
    campaignLabel(){
        return this.campaignswitch?'Yes':'No';
    }

  },
  async mounted () {
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }

    this.test_email = this.currentUser.email;
    this.templateEdited = true;
    this.companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = this.companymeta.primary_color 
    this.company_default_language = this.currentUser.company.language.lang_code;
    this.tabs = this.currentUser.company.language.lang_code;
    if(this.companysettings.hasOwnProperty('setting_data')){
      this.timezone = this.companysettings.setting_data.timezone
    }

    if(Object.keys(this.sindividualtemplate).length >0){
      this.template_id = this.sindividualtemplate.sc_temp_id
      this.template_name =   this.sindividualtemplate.schedule_template_name
      this.frequency   =   this.sindividualtemplate.frequency
      this.cycles   =   this.sindividualtemplate.cycles
      this.start_date   =   this.sindividualtemplate.start_date
      this.start_time   =   this.sindividualtemplate.start_time

      if(this.sindividualtemplate.cycles!=0 && ((this.sindividualtemplate.cycles - this.sindividualtemplate.from_cycle)<=0)){
        this.cycleerrors = "Mail Cycle Count is Over. Increase Cycle Count if you want to keep sending mails"
      }
      
      if(this.sindividualtemplate.groups.length){
        this.sendGroup='group';
        await this.getRecipients();
        this.userGroupList = this.sindividualtemplate.groups;
      }
      else if(this.sindividualtemplate.users.length){
        this.sendGroup='users';
        await this.getRecipients();
        this.userList = this.sindividualtemplate.users;
      }
      else{
        this.sendGroup=this.sindividualtemplate.recipient_type;
      }


    let last_from_cycle = this.sindividualtemplate.schedule_mail_template_messages[this.sindividualtemplate.schedule_mail_template_messages.length-1].from_cycle ;
    if((last_from_cycle == this.cycles) && (last_from_cycle!=1)){
        this.reachedMaxTemplateCount = true;
    }
    if(last_from_cycle > 1){
      this.campaignswitch = true;
    }

    if(this.campaignswitch){
      //initialize array with from_cycle values
        var from_cycle1 = 0;
        let iterator = 0;
        this.sindividualtemplate.schedule_mail_template_messages.forEach((item1) => {
          from_cycle1 = item1.from_cycle;
          const found = (this.emailtemplates).some(el => el.from_cycle === from_cycle1);
          if(from_cycle1==item1.from_cycle && !found){
          iterator = iterator + 1;
            this.emailtemplates.push({ 
                element_count: iterator,
                from_cycle : item1.from_cycle,
                to_cycle : item1.from_cycle,
                template_subject : [],
                template : [],
            });
          }
        }); 
        
        this.sindividualtemplate.schedule_mail_template_messages.forEach((item1) => {
            this.template_subject = [];
            this.template = [];
            this.availablelanguages.forEach((lang, index) => {
              this.sindividualtemplate.schedule_mail_template_messages.forEach((item2) => {
                if(lang.lang_code === item2.lang_code && item1.from_cycle === item2.from_cycle){
                    this.$set(this.template_subject, index , item2.subject);
                    this.$set(this.template, index , item2.body) 
                }
              });
          });

          var elementindex = this.emailtemplates.findIndex(item => item.from_cycle==item1.from_cycle);
          this.emailtemplates[elementindex].template_subject = this.template_subject;
          this.emailtemplates[elementindex].template = this.template;

        });
    }
    else{
      this.availablelanguages.forEach((lang,index) => {
          this.sindividualtemplate.schedule_mail_template_messages.forEach((item) => {
          if(lang.lang_code === item.lang_code){
              this.$set(this.template_subject, index , item.subject);
              this.$set(this.template, index , item.body) 
          }
          });
      });
    }

    }
  },
  data: function() {
    return {
      template_id: null,
      template_name: null,
      template_language :null,
      isLoading:false,
      primary_color:null,
      test_mail:true,
      test_mail_input:false,
      test_email:null,
      templateEdited:false,

      template_subject: [],
      template: [],
      schedule_mail_template_messages:[],
      company_default_language:null,

      sendGroup: false,
      users:[],
      groups:[],
      userList:[],
      userGroupList:[],
      frequency:null,
      menu: false,
      start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      start_time: "00:00",
      cycles: 0,
      userEmail:"{{userEmail}}",
      userName:"{{userName}}",
      menu2: false,
      tabs:null,
      campaigntabs:[],
      timezone:null,
      missing_fields_error_message:'',
      cycleerrors:null,

      campaignswitch:false,
      reachedMaxTemplateCount:false,
      emailtemplates:[],
      from_cycle: [],
      from_error_message: [],
      sendingTestMailInProgress: false
    }
  },
  watch: {
    // whenever template changes, this function will run
    template(newValue, oldValue) {
      if(oldValue){
        if(newValue !== oldValue){
          this.templateEdited = false;
        }
      }
    },
    campaignswitch(){
        if(this.emailtemplates.length==0){
            this.emailtemplates.push({ 
                element_count: this.emailtemplates.length+1,
                from_cycle : 1,
                to_cycle : this.cycles,
                template_subject : [],
                template : [],
            })
        }
    }
  },
  methods : {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('has-access-to-scheduled-mails') ){
        return true;
      }
      return false;
    },
    addTemplate () {
        if(this.emailtemplates.length==5){
            alert("You cannot add more than 5 templates");
            return;
        }
        this.emailtemplates.push({ 
          element_count: this.emailtemplates.length+1,
          from_cycle : 0,
          to_cycle : this.cycles,
          template_subject : [],
          template : [],
        })

    },
    validateextrafields(index){
      this.from_error_message[index]=null;
        if(parseInt(this.emailtemplates[index]['from_cycle']) == this.cycles){
            this.reachedMaxTemplateCount = true;
            return;
        }
        if(parseInt(this.emailtemplates[index]['from_cycle']) > this.cycles){
            this.emailtemplates[index]['from_cycle'] = '';
            this.from_error_message[index] = "Please insert a number less than or equal to Total Cycles "+this.cycles;
            return;
        }
        if(parseInt(this.emailtemplates[index]['from_cycle']) <= parseInt(this.emailtemplates[index-1]['from_cycle'])){
            this.emailtemplates[index]['from_cycle'] = '';
            this.from_error_message[index] = "Please insert a number greater than previous Cycle "+parseInt(this.emailtemplates[index-1]['from_cycle']);
            return;
        }
        this.reachedMaxTemplateCount = false;
        this.emailtemplates[index-1]['to_cycle'] = this.emailtemplates[index]['from_cycle']-1;
    },
    resetCycleCounts(){
        if(this.campaignswitch){
        this.emailtemplates[this.emailtemplates.length-1]['to_cycle'] = this.cycles;
        }
    },
    async getRecipients(){
        if(this.sendGroup=='users'){
            await this.$store.dispatch(FETCH_USERS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.users = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
            });
        }
        else{
            await this.$store.dispatch(FETCH_GROUPS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.groups = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
            });
        }
    },
    toggleMailInput(){
      this.test_mail = false;
      this.test_mail_input = true;
    },
    sendTestMail(lang, from_cycle){
      if (this.$refs.form.validate()) {
        this.sendingTestMailInProgress = true;

        let data = {
            email: this.test_email,
            lang_code: lang.lang_code,
            from_cycle: from_cycle,
            sc_temp_id: this.template_id
          }
        
        this.$store
          .dispatch(SEND_SCHEDULED_TEST_MAIL, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Mail Sent! Please check email'})
              store.commit(SET_LOADING, false)
              this.test_mail = true;
              this.test_mail_input = false;
              this.sendingTestMailInProgress = false;
            }
            else{
              store.commit(SET_LOADING, false)
              this.sendingTestMailInProgress = false;
            }
          });
      }
    },
    addplaceholder(placeholder) {
        const insertText = placeholder
        if (!insertText.length) return

        navigator.clipboard.writeText(placeholder).then(() => {
          /* clipboard successfully set */
          document.getElementById("custom-tooltip").style.display = "inline";
          setTimeout( function() {
              document.getElementById("custom-tooltip").style.display = "none";
          }, 1000);
        }, () => {
          /* clipboard write failed */
        });
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            schedule_template_name: this.template_name,
            mail_language:"en",
            recipient_type:this.sendGroup,
            frequency:this.frequency,
            cycles:this.cycles,
            start_date:this.start_date,
            start_time:this.start_time,
          }

          if(this.sendGroup=='group'){
            data["groups"] = this.userGroupList;
          }
         else if(this.sendGroup=='users'){
            data["users"] = this.userList;
          }
          else if(this.sendGroup=='all_users'){
            data["all_users"] = true;
          }

        if(this.campaignswitch){
            this.emailtemplates.forEach((et) => {
                this.availablelanguages.forEach((lang,index) => {
                    if(et.template_subject[index]!=""){
                        if(et.template_subject[index]!=null){
                            this.schedule_mail_template_messages.push({
                                "from_cycle": et.from_cycle,
                                "lang_code": lang.lang_code,
                                "subject": et.template_subject[index],
                                "body": et.template[index]
                            });
                        }
                    }
                });
            });
        }
        else{
             this.availablelanguages.forEach((lang,index) => {
                if(this.template_subject[index]!=""){
                if(this.template_subject[index]!=null){
                    this.schedule_mail_template_messages.push({
                        "from_cycle": 1,
                        "lang_code": lang.lang_code,
                        "subject": this.template_subject[index],
                        "body": this.template[index],
                    })
                }
                }
            });
        }
          data["schedule_mail_template_messages"] = this.schedule_mail_template_messages;

          if(data["schedule_mail_template_messages"].length==0){
            this.missing_fields_error_message = "You need to fill the at least one language, Email Subject and Email Body";
            return;
          }

        this.$store
          .dispatch(ADD_SCHEDULED_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Notification Template created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push("/scheduled-mail-notification/edit/" + resp.data.sc_temp_id)
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {

        let data = {
            id: this.template_id,
            schedule_template_name: this.template_name,
            recipient_type:this.sendGroup,
            frequency:this.frequency,
            cycles:this.cycles,
            start_date:this.start_date,
            start_time:this.start_time,
            _method: "put"
          };
          if(this.sendGroup=='group'){
            data["groups"] = this.userGroupList;
          }
          else if(this.sendGroup=='users'){
            data["users"] = this.userList;
          }
          else if(this.sendGroup=='all_users'){
            data["all_users"] = true;
          }

          this.schedule_mail_template_messages =[];

          if(this.campaignswitch){
            this.emailtemplates.forEach((et) => {
                this.availablelanguages.forEach((lang,index) => {
                    if(et.template_subject[index]!=""){
                        if(et.template_subject[index]!=null){
                            this.schedule_mail_template_messages.push({
                                "from_cycle": et.from_cycle,
                                "lang_code": lang.lang_code,
                                "subject": et.template_subject[index],
                                "body": et.template[index]
                            });
                        }
                    }
                });
            });
          }
          else{
            this.availablelanguages.forEach((lang,index) => {
                if(this.template_subject[index]!=""){
                if(this.template_subject[index]!=null){
                    this.schedule_mail_template_messages.push({
                    "from_cycle": 1,
                    "lang_code": lang.lang_code,
                    "subject": this.template_subject[index],
                    "body": this.template[index],
                    })
                }
                }
            });
          }
          data["schedule_mail_template_messages"] = this.schedule_mail_template_messages;

          if(data["schedule_mail_template_messages"].length==0){
            this.missing_fields_error_message = "You need to fill the at least one language, Email Subject and Email Body";
            return;
          }

        this.$store
          .dispatch(UPDATE_SCHEDULED_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Email Notification successfully Updated'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "scheduledmail" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    handleDelete(index){
      if(this.campaignswitch){
        this.emailtemplates.splice(index, 1);
      }
    }

  },
};
</script>

<style scoped>
[contenteditable] {
  outline: 0px solid transparent;
}

.btn.disabled {
    pointer-events: auto;
}

.test-mail-section{
  float: right;
}
#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
    background-color: #000000df;
    border-radius: 4px;
    color: #fff;
}
</style>